export const getBaseUrl = ({ protocol, hostname, port }) => {
    if (!Boolean(protocol) || !Boolean(hostname)) {
        throw Error('missing protocol or hostname');
    }
    const protocolValue = Boolean(protocol) ? `${protocol}//` : '';
    const portValue = Boolean(port) ? `:${port}` : '';
    return `${protocolValue}${hostname}${portValue}`;
};
